export const TABLE_COLUMN_WIDTHS = {
  SELECTION: 64,
  SELECTION_COMPACT: 40,
  EXPANDABLE: 64 - 16, // ADD pl-4 to the column
  DEFAULT: 120,
  ACTION: 64 + 32, // Factoring in px-4 to the column
  ACTION_BUTTON: 100 + 32, // Factoring in px-4 to the column
} as const;

export const ACTION_COLUMN_DEFAULT_PROPS = {
  header: "",
  isMobileAction: true,
  id: "action",
  minSize: TABLE_COLUMN_WIDTHS.ACTION,
  size: TABLE_COLUMN_WIDTHS.ACTION,
  maxSize: TABLE_COLUMN_WIDTHS.ACTION,
  addCellTooltip: false,
  align: "right",
  className: "px-4 mx-0 [&_button]:p-0",
  enableSorting: false,
} as const;

export const ACTION_COLUMN_BUTTON_DEFAULT_PROPS = {
  ...ACTION_COLUMN_DEFAULT_PROPS,
  minSize: TABLE_COLUMN_WIDTHS.ACTION_BUTTON,
  size: TABLE_COLUMN_WIDTHS.ACTION_BUTTON,
  maxSize: TABLE_COLUMN_WIDTHS.ACTION_BUTTON,
} as const;

export const MAX_TEXT_COLUMN_PROPS = {
  maxSize: 200,
  size: 200,
  addCellTooltip: true,
} as const;

// Tanstack table automatically sets the min size to 20px, so we need to set the max size to the max safe integer
export const DEFAULT_COLUMN_MIN_SIZE = 20;
export const DEFAULT_COLUMN_MAX_SIZE = Number.MAX_SAFE_INTEGER - 1;
